export default __webpack_public_path__ + "static/media/logo_print.3065a2b2.png";